export const DEFAULT_TRANSACTION_FEES = {
  CARD_TRANSACTION_PERCENTAGE: '2.9',
  AUD_CARD_TRANSACTION_PERCENTAGE: '1.75',
  CARD_FIXED: '0.30',
  ACH_TRANSACTION_PERCENTAGE: '0.8',
  NO_FEE: '0',
} as const;

export const PASS_TRANSACTION_FEES_DISCLOSURE =
  'Note: Surcharge laws vary by state and country. Some jurisdictions restrict or prohibit passing processing fees to customers. It is your responsibility to verify compliance with applicable local laws before enabling this feature. When in doubt, consult a legal professional.';

export const PASS_ALONG_LINK_DISABLED_NOTICE =
  'Stripe Link cannot receive a pass-along transaction fee because the underlying card or bank funding type is hidden. Because you override Stripe payment method settings, we will disable Stripe Link so parents must add a card or bank account instead.';

export const PASS_ALONG_LINK_NOT_CHARGED_NOTICE =
  'Stripe Link cannot receive a pass-along transaction fee because the underlying card or bank funding type is hidden. Parents who pay with Link will not be charged the fee. To automatically disable Link, turn on “Override Stripe Payment Methods Configuration” in Payment Settings.';

export const ENABLE_LINK_WHILE_PASS_ALONG_NOTICE =
  'Stripe Link cannot be enabled while pass-along transaction fees are on. Link hides the underlying card or bank funding type, so the fee cannot be applied safely. Disable pass-along fees first, or leave Link disabled.';
